import classNames from "classnames";
import classes from "./IconButton.module.scss";

export const IconButton = ({ interactive = true, ...props }) => {
  return (
    <button
      {...props}
      className={classNames(
        { [classes["interactive"]]: interactive },
        classes["icon-button"],
        props.className
      )}
      type={props.type || "button"}
    />
  );
};
